<template>
  <div>
    <h2 class="text-2xl font-bold mb-8">General</h2>

    <FormulateForm
      :name="formName"
      v-model="formValues"
      @submit="submit"
      :key="`image-${currentSegment.id}`"
    >
      <FormulateInput
        type="text"
        name="name"
        label="Name"
        validation="required"
      />
      <FormulateInput
        type="text"
        name="short_name"
        label="Short name"
        validation="optional|between:-1,3,length"
        validation-name="Short name"
        :validation-messages="{
          between: 'Short name has to be 1-2 characters long.',
        }"
      />
      <FormulateInput
        type="select"
        name="tracking_code_logic"
        label="Tracking code logic"
        validation="required"
        :options="{
          UNIQUE_ID: 'Unique ID',
          EXACT_VALUES: 'Exact values',
          CHANNEL_COUNTRY_CAMPAIGN_UNIQUE_ID:
            'Channel / Country / Campaign prefixes',
          CHANNEL_PREFIX_UNIQUE_ID: 'Channel prefix',
          EXACT_VALUES_UNIQUE_ID: 'Exact values',
          ABBREVIATED_VALUES_UNIQUE_ID: 'Abbreviated values',
        }"
      />

      <base-button type="submit" :loading="saving">
        Save
      </base-button>
    </FormulateForm>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      formName: `segmentForm`,
      saving: false,
      formValues: {},
    };
  },
  computed: {
    ...mapGetters('company/segment', ['currentSegment']),
  },
  watch: {
    currentSegment(segment) {
      this.formValues = segment;
    },
  },
  mounted() {
    this.formValues = this.currentSegment;
  },
  methods: {
    async submit(data) {
      try {
        this.saving = true;
        await this.$store.dispatch('company/segment/updateSegment', data);
      } catch (error) {
        this.$formulate.handle(error, this.formName);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
